export enum ETextTone {
    BUSINESS = 'business',
    FRIENDLY = 'friendly',
    FUNNY = 'funny',
    CEREMONIAL = 'ceremonial',
}
